import {stateData, reduxState} from '../../values';

const initialState = {
    vehicles:       [],
    status:         stateData.state1,
    vehiclesEdit:   [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_vehicles){
        return {
            ...state,
            vehicles:   action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_vehicles){
        return {
            ...state,
            vehiclesEdit: action.payload
        }
    }
    return state
}
export default reducer